import domReady from "@wordpress/dom-ready";

domReady(() => {
    const sliders = document.querySelectorAll(".wp-block-celebrate-suite-celebrate-sliding-content");

    sliders.forEach((slider) => {
        const slidingLevel = parseInt(slider.getAttribute('data-sliding-level')) || 1;
        let galleries = [];

        function findGalleries(element, level) {
            if (level === 1) {
                galleries.push(element);
                return;
            }
            Array.from(element.children).forEach(child => {
                findGalleries(child, level - 1);
            });
        }

        findGalleries(slider, slidingLevel);

        const navigation = slider.getAttribute('data-navigation') === 'true';
        const pagination = slider.getAttribute('data-pagination') === 'true';
        const autoplay = slider.getAttribute('data-autoplay') === 'true';
        const autoplaySpeed = parseInt(slider.getAttribute('data-autoplay-speed')) || 4000;
        const groupCells = slider.getAttribute('data-group-cells') === 'true';
        const arrowImageUrl = slider.getAttribute('data-arrow-image-url');
        const arrowChoice = slider.getAttribute('data-arrow-choice');
        const columnCountAttr = slider.getAttribute('data-column-count');
        const blockGap = slider.getAttribute('data-block-gap');

        let prevArrow = '';
        let nextArrow = '';

        if (arrowChoice === 'image' && arrowImageUrl) {
            prevArrow = `
                <button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous">
                    <img src="${arrowImageUrl}" style="transform: scaleX(-1);" alt="Previous Arrow" />
                </button>`;
            nextArrow = `
                <button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next">
                    <img src="${arrowImageUrl}" alt="Next Arrow" />
                </button>`;
            } else if (arrowChoice === 'arrow') {
                prevArrow = `
                    <button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256">
                            <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"></path>
                        </svg>
                    </button>`;
                nextArrow = `
                    <button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256">
                            <path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"></path>
                        </svg>
                    </button>`;
            } else {
            prevArrow = `
                <button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous">
                    <svg class="flickity-button-icon" viewBox="0 0 100 100">
                        <path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path>
                    </svg>
                </button>`;
            nextArrow = `
                <button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next">
                    <svg class="flickity-button-icon" viewBox="0 0 100 100">
                        <path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180)"></path>
                    </svg>
                </button>`;
        }

        if (columnCountAttr) {
            const columnCount = parseInt(columnCountAttr);
            const viewportWidth = window.innerWidth;
            let slideWidth;

            if (viewportWidth > 1200) {
                let gapValue = 0;
                if (blockGap) {
                    const gapUnit = blockGap.replace(/[0-9]/g, '');
                    gapValue = parseFloat(blockGap) * (columnCount - 1) + gapUnit;
                }
                slideWidth = `calc((100% - ${gapValue}) / ${columnCount})`;
            } else if (viewportWidth > 600) {
                slideWidth = `calc(50% - ${blockGap}/2)`;
            } else {
                slideWidth = '100%';
            }

            const slides = slider.querySelectorAll('.wp-block-post');
            slides.forEach(slide => {
                slide.style.width = slideWidth;
                slide.style.marginRight = viewportWidth > 600 ? blockGap : '0';
            });
        }

        galleries.forEach(gallery => {
            const flickityInstance = new Flickity(gallery, {
                cellAlign: "left",
                contain: true,
                draggable: true,
                wrapAround: true,
                imagesLoaded: true,
                autoPlay: autoplay ? autoplaySpeed : false,
                prevNextButtons: false,
                pageDots: pagination,
                groupCells: groupCells
            });

            if (navigation) {
                slider.insertAdjacentHTML('beforeend', prevArrow);
                slider.insertAdjacentHTML('beforeend', nextArrow);

                const prevButton = slider.querySelector('.flickity-prev-next-button.previous');
                const nextButton = slider.querySelector('.flickity-prev-next-button.next');

                prevButton.addEventListener('click', () => {
                    flickityInstance.previous();
                });

                nextButton.addEventListener('click', () => {
                    flickityInstance.next();
                });
            }
        });
    });
});
